(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function() {
  var mobileBtn = document.getElementById('mobile-filter-btn');
  var filters = document.getElementById('coll-filters');
  var overlay = document.getElementById('filters-overlay');

  if (mobileBtn && filters) {
    mobileBtn.addEventListener('click', function() {
      var open = filters.classList.toggle('is-open');
      mobileBtn.setAttribute('aria-expanded', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function() {
      if (filters) filters.classList.remove('is-open');
      if (mobileBtn) mobileBtn.setAttribute('aria-expanded', 'false');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  document.querySelectorAll('[data-filter-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      var target = btn.closest('.coll-filter-group').querySelector('.coll-filter-group__body');
      if (target) target.classList.toggle('is-collapsed', expanded);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
